<template>
  <div id="vy_footer">
    <!--
    <div id="vy_footer_list" class="container-fluid p-5">
      <div class="row">
        <div class="col-6">
          <h3 align="left">ボラ活エール</h3>
          <p class="vy-footer-p">ボラ活エールはボランティア活動をしたい個人と団体とボランティア活動をむすぶサイトです</p><br>
        </div>
        <div class="col-6">
          <p class="vy-footer-list">
            <a href="#">ボランティア活動・セミナーを探す</a>
          </p>
          <ul class="list-unstyled vy-footer-list">
            <li><a href="#" v-on:click="volukatsu_yell_towa">ボラ活エールとは</a></li>
            <li><a href="#" v-on:click="faq">よくある質問</a></li>
            <li><a href="#" v-on:click="toiawase">お問合せ</a></li>
            <li><a href="#">サイトマップ</a></li>
          </ul>
        </div>
      </div>
    </div>-->
    <div id="vy_copyright" class="container-fluid pc_only">
      <!--
      <div class="row ">
        <div class="col-4"><a href="#" v-on:click="shakyo_policy">プライバシーポリシー（社協）</a></div>
        <div class="col-5"><a href="#" v-on:click="privacy_policy">プライバシーポリシー（ボラ活エール）</a></div>
        <div class="col-3"><a href="#" v-on:click="riyo_kiyaku">利用規約</a></div>
      </div>-->
      
      <div class="col-12" style="margin-top: 10px;">&copy;ボラ活エール All Rights Reserved.</div>
    </div>

    <div id="vy_copyright" class="container-fluid sp_only">
    
      <div style="font-size: 0.9em;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size:12.5px">
        <div class="row ">
          <div class="col-12" style="margin-bottom:15px;font-size:13px"><a href="#" v-on:click="riyo_kiyaku"><u>利用規約</u></a></div><br>
          <span class="col-6"><a href="#" v-on:click="shakyo_policy"><u>プライバシーポリシー<br>（社協）</u></a></span>
          <span class="col-6"><a href="#" v-on:click="privacy_policy"><u>プライバシーポリシー<br>（ボラ活エール）</u></a></span>
          <div class="col-12" style="margin-top: 15px;">&copy;ボラ活エール All Rights Reserved.</div>
        </div>
      </div>
    </div>
  </div>
<!--  <div>
  <hr>
  <span v-on:click="volukatsu_yell_towa" style="cursor:pointer">ボラ活エールとは&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="riyo_kiyaku" style="cursor:pointer">利用規約&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="kojin_joho_hogo_hoshin" style="cursor:pointer">個人情報保護方針&nbsp;&nbsp;&nbsp;&nbsp;</span><br/>
  <span v-on:click="privacy_policy" style="cursor:pointer">プライバシーポリシー&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="faq" style="cursor:pointer">よくある質問&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="toiawase" style="cursor:pointer">お問合せ&nbsp;&nbsp;&nbsp;&nbsp;</span>
  </div>
  <div id="by_copyright" class="container-fluid" style="margin-top:20px">
    <div class="row">
      <div class="col-12">&copy;ボラ活エール  All Rights Reserved.</div>
    </div>
  </div> -->
</template>

<script setup>
/* eslint-disable */
import { useRouter,useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

//------------------------------ リンク --------------------------------
const volukatsu_yell_towa = function() { router.push('/Ippan/volukatsu_yell_towa') }
const riyo_kiyaku = function() { 
    let set_path = "/Condition"
    window.open(set_path,"_blank")}
const privacy_policy = function() { 
    let set_path = "/Policy"
    window.open(set_path,"_blank")
}
const shakyo_policy = function() { 
    router.push( "/"+route.params.shakyo+"/Taiken/Policy")
}
const kojin_joho_hogo_hoshin = function() { router.push('/Ippan/kojin_joho_hogo_hoshin') }
const faq = function() { router.push('/Ippan/faq') }
const toiawase = function() { router.push('/Ippan/toiawase') }
</script>

<style scoped>

@media screen and (min-width: 971px) {
/* PC */
  .footer_pc_only{
    display: block
  }

  .footer_sp_only{
    display: none
    
  }
}

@media screen and (max-width: 970px) {
/* スマホ */
  .footer_pc_only{
    display: none
  }

  .footer_sp_only{
    display: block
    
  }
}
</style>
